/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resetPastAttempts} from '../api'

export const useMutationResetPastAttempts = createReactQueryMutationHook('resetPastAttempts', resetPastAttempts)
